import { render, staticRenderFns } from "./DashboardGestaoAnalyticsStatus.vue?vue&type=template&id=2cbf91ea&scoped=true"
import script from "./DashboardGestaoAnalyticsStatus.vue?vue&type=script&lang=js"
export * from "./DashboardGestaoAnalyticsStatus.vue?vue&type=script&lang=js"
import style0 from "./DashboardGestaoAnalyticsStatus.vue?vue&type=style&index=0&id=2cbf91ea&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbf91ea",
  null
  
)

export default component.exports